import styled from 'styled-components';
import twTheme from '../../../styles/theme';

export const SkipWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  min-height: 80px;
  padding: 10px;
  margin: auto;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  border: solid ${twTheme.colour.emerald};
  border-width: 0 2px 2px 2px;
  background-color: ${twTheme.colour.mint};
  opacity: 0;
  z-index: 1000;
  transform: translateY(-100%);
  &:focus-within {
    transform: translateY(0%);
    transition: transform 0.3s ease-in-out;
    opacity: 1;
  }
`;

export const SkipLink = styled.a`
  color: ${twTheme.colour.emerald};
  font-size: 18px;
  line-height: 1;
  text-align: center;
  padding: 10px;
  text-decoration: none;
  border-radius: 0 0 6px 6px;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
`;
